import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { InventoryResponse } from 'app/typings/core/extranet/inventory/autoInventory';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '..';

export const autoInventoryInventoryQuery = (hotelId: number) => ({
  queryKey: [CORE_QUERY_KEYS.autoInventoryInventory, hotelId],
  queryFn: () =>
    apiRequest({
      path: ENDPOINTS.getAutoInventoryInventory,
      params: { hotelId: hotelId.toString() },
    }) as Promise<InventoryResponse>,
  staleTime: 5 * MILLISECONDS_IN_MINUTE,
  enabled: !!hotelId,
});

export function useAutoInventoryInventory(
  hotelId: number,
  options?: { enabled?: boolean }
) {
  return useQuery({
    ...autoInventoryInventoryQuery(hotelId),
    enabled: (options?.enabled ?? true) && !!hotelId,
  });
}
